import React from 'react'
import { useSelector } from 'hook'
import { Typography, Grid } from '@material-ui/core'
import { LANGUAGE } from 'constants/language'
import useStyles from './style'
import { TitleText } from 'text/part'
import { AllInclusive } from '@material-ui/icons'
import { animateScroll } from 'react-scroll'

const TitleBar = () => {
  const classes = useStyles()
  const languageManager = useSelector((state) => state.languageManager)
  return (
    <Grid
      container
      item
      direction="row"
      justify="flex-end"
      alignItems="center"
      className={classes.grid}
      onClick={() => {
        animateScroll.scrollToTop({ smooth: true })
      }}
    >
      <Grid item>
        <AllInclusive className={classes.icon} fontSize="large" />
      </Grid>
      <Grid item>
        <Typography className={classes.title}>
          {languageManager === LANGUAGE.JP
            ? TitleText.main.jp
            : TitleText.main.en}
        </Typography>
      </Grid>
      <Grid item>
        <AllInclusive className={classes.icon} fontSize="large" />
      </Grid>
    </Grid>
  )
}

export default TitleBar
